import { create } from 'zustand'
import { DetectedColumn, JobLog, ProcessingJob } from '../api'

interface ProcessingState {
  currentDocumentId: string | null
  currentJob: ProcessingJob | null
  logs: JobLog[]
  detectedColumns: DetectedColumn[]
  selectedColumnIds: string[]
  setCurrentDocument: (id: string | null) => void
  setCurrentJob: (job: ProcessingJob | null) => void
  addLog: (log: JobLog) => void
  setDetectedColumns: (columns: DetectedColumn[]) => void
  setSelectedColumnIds: (ids: string[]) => void
  reset: () => void
}

export const useProcessingStore = create<ProcessingState>((set) => ({
  currentDocumentId: null,
  currentJob: null,
  logs: [],
  detectedColumns: [],
  selectedColumnIds: [],
  setCurrentDocument: (id) => set({ currentDocumentId: id }),
  setCurrentJob: (job) => set({ currentJob: job }),
  addLog: (log) => set((state) => ({ logs: state.logs.some((item) => item.id === log.id) ? state.logs : [...state.logs, log] })),
  setDetectedColumns: (columns) => set({ detectedColumns: columns, selectedColumnIds: columns.map((column) => column.id) }),
  setSelectedColumnIds: (ids) => set({ selectedColumnIds: ids }),
  reset: () => set({ currentDocumentId: null, currentJob: null, logs: [], detectedColumns: [], selectedColumnIds: [] }),
}))
